import { useEffect, useState } from 'react'
import { ChevronDownIcon, SearchIcon } from '../../../../../icons'
import { Input, Label } from '../../../../core'

import { InputSearchProps } from './input-search.type'

export const InputSearch = ({
  onChange,
  value,
  onOpen,
  error,
  translations,
  hasLabel = true,
  ref,
  onKeyDown,
}: InputSearchProps) => {
  const [localValue, setLocalValue] = useState(value)

  useEffect(() => {
    if (value !== localValue) setLocalValue(value)
  }, [value])

  useEffect(() => {
    const handler = setTimeout(() => {
      if (localValue === value) return
      onChange(localValue)
    }, 500)
    return () => clearTimeout(handler)
  }, [localValue, onChange])

  return (
    <>
      {hasLabel && <Label>{translations?.inputSearchLabel || ''}</Label>}
      <Input
        aria-label={translations.inputSearchPlaceholder}
        placeholder={translations.inputSearchPlaceholder}
        iconLeft={<SearchIcon />}
        iconRight={<ChevronDownIcon />}
        value={localValue}
        onChange={setLocalValue}
        onClick={() => onOpen(true)}
        error={error}
        ref={ref}
        onKeyDown={onKeyDown}
      />
    </>
  )
}
